import {InputItem, OpenEndedQuestionParagraph, TextItem} from '../models';

const inputMarker = '[]';
const paragraphSeparator = '\n';

interface InputPositionResult {
  start: number,
  end: number
}

function countInputs(value: string): number {
  let currentPos = 0;
  let result = 0;

  let position = value.indexOf(inputMarker, currentPos);
  while (position !== -1) {
    currentPos = position + inputMarker.length;
    result++;
    position = value.indexOf(inputMarker, currentPos);
  }
  return result;
}

function* findInputPositions(value: string): Generator<InputPositionResult> {
  let currentPos = 0;

  let position = value.indexOf(inputMarker, currentPos);
  while (position !== -1) {
    yield {start: position, end: position + inputMarker.length};
    currentPos = position + inputMarker.length;
    position = value.indexOf(inputMarker, currentPos);
  }
}

function deserializeParagraph(line: string): (TextItem | InputItem)[] {
  let result: (TextItem | InputItem)[] = [];
  let lastPosition = 0;

  function addTextItem(start: number, end: number) {
    if (start === end)
      return;
    const content = line.substring(start, end);
    let item: TextItem = {
      type: 'text',
      content: content
    };
    result.push(item);
  }

  function addInputItem() {
    result.push({type: 'input'});
  }

  for (let selectPosition of findInputPositions(line)) {
    addTextItem(lastPosition, selectPosition.start);
    addInputItem();
    lastPosition = selectPosition.end;
  }

  addTextItem(lastPosition, line.length);
  return result;
}

function splitLines(value: string): string[] {
  function notEmptyLine(line: string): boolean {
    line = line.trim();
    return (line !== '');
  }

  return value.split(paragraphSeparator).filter(notEmptyLine);
}

function deserializeParagraphs(value: string): OpenEndedQuestionParagraph[] {
  // reversed, because we are going to pop select items.
  let result: OpenEndedQuestionParagraph[] = [];
  for (let line of splitLines(value)) {
    let paragraphItems = deserializeParagraph(line);
    result.push({items: paragraphItems});
  }
  return result;
}

function serializeParagraph(paragraph: OpenEndedQuestionParagraph): string {
  let result: string[] = [];

  function addText(item: TextItem) {
    result.push(item.content);
  }

  function addInput() {
    result.push(inputMarker);
  }

  for (let item of paragraph.items) {
    if (item.type === 'text')
      addText(item);
    if (item.type === 'input')
      addInput();
  }
  return result.join('');
}

function serializeParagraphs(paragraphs: readonly OpenEndedQuestionParagraph[]): string {
  return paragraphs.map((p) => serializeParagraph(p))
    .join(paragraphSeparator);
}


/******************************************************************************/

class OpenEndedQuestionInlineCrudHelper {
  readonly countInputs = countInputs;
  readonly deserializeParagraphs = deserializeParagraphs;
  readonly serializeParagraphs = serializeParagraphs;
}

export const crudHelper = new OpenEndedQuestionInlineCrudHelper();
